<div (window:resize)="debouncedOnResize()">
    @if (showBox) {
        <div (click)="revealElements()"
             class="note-info-box row">
            <div class="col-xs-1 col-sm-1">
                <i (click)="hideBox()" class="fa fa-times"></i>
            </div>
            <div class="col-xs-9 col-sm-9">
                <em>Notizen hinzufügen</em>
                <br/>
                <p>Mit diesen Werkzeug in der rechten Toolbar können Sie Notizen und Markierungen hinzufügen.</p>
            </div>
            <div class="col-xs-2 col-sm-2">
                <img [attr.src]="noteInfoIconUrl" alt="Icon für Notizen">
            </div>
        </div>
    }
</div>